module.exports = __webpack_public_path__ + "fonts/CalibreBlackItalic.1d5dd79a.woff";